module.exports = __webpack_public_path__ + "img/newsImg6.b6c904b6.png";